module.exports = __webpack_public_path__ + "img/production.59ef0e08.png";